import React, { Component } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-bootstrap-typeahead/css/Typeahead-bs4.css";
import "./organizationLocation.css";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import csc from "country-state-city";
// import "react-phone-number-input/style.css";
// import PhoneInput from "react-phone-number-input";
// import { isValidPhoneNumber } from "react-phone-number-input";

export default class OrganizationLocation extends Component {
  constructor(props) {
    super(props);
    this.locationForm = React.createRef();
  }

  onSubmit = (values) => {
    if (values.Country.length === 1) {
      values.CountryId = values.Country[0].id;
      values.Country = values.Country[0].name;
    }
    if (values.State.length === 1) {
      values.StateId = values.State[0].id;
      values.State = values.State[0].name;
    }
    if (values.City.length === 1) {
      values.CityId = values.City[0].id;
      values.City = values.City[0].name;
    }
    var data = {
      orgLocation: {},
    };
    for (var key in values) {
      if (key !== "speciality" && key !== "Type")
        data.orgLocation[key] = values[key];

      if (key === "speciality") {
        //var SpecialityIds = values.speciality.map(el => el.id);
        data.orgLocation["SpecialityIds"] = JSON.stringify(
          values["speciality"]
        );
      }
      if (key === "Type") {
        data.orgLocation["Type"] = JSON.stringify(values["Type"]);
      }
    }
    data["onBoarding"] = this.props.onBoarding;
    if (this.props.addAnotherLocation) data["addAnotherLocation"] = true;
    else data["addAnotherLocation"] = false;
    this.props.setOrganizationLocation(data);
  };

  validationSchema = Yup.object().shape({
    Country: Yup.string().required("Country is required"),
    PrimaryAddress: Yup.string().required("Primary Address is required"),
    City: Yup.string().required("City is required"),
    State: Yup.string().required("State is required"),
    Zipcode: Yup.string().required("Zipcode is required"),
    LocationContactEmail: Yup.string()
      .email("Location Contact Email is not valid")
      .required("Location Contact Email is required"),
    PrimaryLocationName: Yup.string().required("Primary Location is required"),
    Type: Yup.array().min(1, "Type is required"),
    // Fax: Yup.string().required("Fax is required"),
    LocationContact: Yup.string().required("Location Contact is required"),
    speciality: Yup.array().min(1, "Speciality is required"),
    Phone: Yup.string().required("Phone number is required"),
    // .test("validPhoneNumber", "Phone number is invalid", value => {
    //   return isValidPhoneNumber(value);
    // }),
  });

  goLastStep = () => {
    this.props.getPrevStep();
  };

  addAnotherLocation = () => {
    this.locationForm.current.resetForm();
    this._typeahead.getInstance().clear();
    this._orgTypeTypeahead.getInstance().clear();
  };

  onSubmitWithAdd = () => {
    this.props.updateAddAnotherLocation(true);
    this.locationForm.current.submitForm();
  };

  onSubmitwithoutAdd = () => {
    this.props.updateAddAnotherLocation(false);
    this.locationForm.current.submitForm();
  };

  renderForm = (props) => {
    const { handleSubmit, values } = props;
    // filter allCountries and return only USA
    let allCountries = csc.getAllCountries();
    let usaCountries = allCountries.filter(
      (country) => country.name === "United States"
    );
    return (
      <form onSubmit={handleSubmit}>
        <div className="form-group form-lable">
          <label className="form-lable">Country</label>
          <Typeahead
            id="basic-typeahead-single"
            options={usaCountries}
            selected={[csc.getCountryById(values.CountryId)]}
            name="Country"
            labelKey="name"
            onChange={(selectedOptions) => {
              if (selectedOptions.length === 1) {
                props.setFieldValue("Country", selectedOptions[0].name);
                // props.setFieldTouched("Country", true, true);
                // values.CountryId = selectedOptions[0].id;
                props.setFieldValue("CountryId", selectedOptions[0].id);
              }
            }}
            onBlur={() => {
              props.setFieldTouched("Country", true, true);
            }}
          />
          <span className="error_text">
            <ErrorMessage name="Country" />
          </span>
        </div>
        <div className="form-group form-lable">
          <label className="form-lable">Primary address</label>
          <Field
            type="text"
            value={values.PrimaryAddress}
            name="PrimaryAddress"
            className="form-control form-input"
          />
          <span className="error_text">
            <ErrorMessage name="PrimaryAddress" />
          </span>
        </div>
        <div className="form-group">
          <div className="row">
            <div className="col-sm-4">
              <label className="form-lable">State</label>
              <Typeahead
                id="basic-typeahead-single"
                options={csc.getStatesOfCountry(values.CountryId)}
                selected={[csc.getStateById(values.StateId)]}
                name="State"
                labelKey="name"
                onChange={(selectedOptions) => {
                  if (selectedOptions.length === 1) {
                    props.setFieldValue("State", selectedOptions[0].name);
                    // props.setFieldTouched("State", true, true);
                    // values.StateId = selectedOptions[0].id;
                    props.setFieldValue("StateId", selectedOptions[0].id);
                  }
                }}
                onBlur={() => {
                  props.setFieldTouched("State", true, true);
                }}
              />
              <span className="error_text">
                <ErrorMessage name="State" />
              </span>
            </div>
            <div className="col-sm-4">
              <label className="form-lable">City</label>

              <Typeahead
                id="basic-typeahead-single"
                options={csc.getCitiesOfState(values.StateId)}
                selected={[csc.getCityById(values.CityId)]}
                name="City"
                labelKey="name"
                onChange={(selectedOptions) => {
                  if (selectedOptions.length === 1) {
                    // console.log(selectedOptions[0].id);
                    props.setFieldValue("City", selectedOptions[0].name);
                    // props.setFieldTouched("City", true, true);
                    // values.CityId = selectedOptions[0].id;
                    props.setFieldValue("CityId", selectedOptions[0].id);
                  }
                }}
                onBlur={() => {
                  props.setFieldTouched("City", true, true);
                }}
                ref={(ref) => (this._typeahead = ref)}
                allowNew
              />
              <span className="error_text">
                <ErrorMessage name="City" />
              </span>
            </div>
            <div className="col-sm-4">
              <label className="form-lable">Zip Code</label>
              <Field
                type="text"
                value={values.Zipcode}
                name="Zipcode"
                className="form-control form-input"
                style={{ marginTop: "2px" }}
                onChange={(e) => {
                  var number = /^[0-9]+$/;
                  if (
                    e.target.value !== "" &&
                    e.target.value.match(number) === null
                  )
                    alert("Please input numeric characters only");
                  else {
                    props.setFieldValue("Zipcode", e.target.value);
                  }
                }}
              />
              <span className="error_text">
                <ErrorMessage name="Zipcode" />
              </span>
            </div>
          </div>
        </div>

        <div className="form-group">
          <div className="row">
            <div className="col-sm-6">
              <label className="form-lable">Location phone </label>
              <Field
                className="form-control form-input"
                name="Phone"
                type="text"
                value={values.Phone}
                ref={this.locationPhone}
                onChange={(e) => {
                  var number = /^[0-9]+$/;
                  if (
                    e.target.value !== "" &&
                    e.target.value.match(number) === null
                  )
                    alert("Please input numeric characters only");
                  else {
                    props.setFieldValue("Phone", e.target.value);
                  }
                }}
              />
              <span className="error_text">
                <ErrorMessage name="Phone" />
              </span>
            </div>
            <div className="col-sm-6">
              <label className="form-lable">Location fax</label>
              <Field
                type="text"
                value={values.Fax}
                name="Fax"
                className="form-control form-input"
                onChange={(e) => {
                  var number = /^[0-9]+$/;
                  if (
                    e.target.value !== "" &&
                    e.target.value.match(number) === null
                  )
                    alert("Please input numeric characters only");
                  else {
                    props.setFieldValue("Fax", e.target.value);
                  }
                }}
              />
              <span className="error_text">
                <ErrorMessage name="Fax" />
              </span>
            </div>
          </div>
        </div>
        <div className="form-group">
          <label className="form-lable">Location contact</label>
          <Field
            type="text"
            value={values.LocationContact}
            name="LocationContact"
            className="form-control form-input"
            onChange={(e) => {
              var name = /^[a-z A-Z]+$/;
              if (e.target.value !== "" && e.target.value.match(name) === null)
                alert("Please input alphabetic characters only");
              else {
                props.setFieldValue("LocationContact", e.target.value);
              }
            }}
          />
          <span className="error_text">
            <ErrorMessage name="LocationContact" />
          </span>
        </div>
        <div className="form-group">
          <label className="form-lable">Location contact email</label>
          <Field
            type="email"
            value={values.LocationContactEmail}
            name="LocationContactEmail"
            className="form-control form-input"
          />
          <span className="error_text">
            <ErrorMessage name="LocationContactEmail" />
          </span>
        </div>
        <div className="form-group">
          <label className="form-lable">Location name</label>
          <Field
            type="text"
            value={values.PrimaryLocationName}
            name="PrimaryLocationName"
            className="form-control form-input"
          />
          <span className="error_text">
            <ErrorMessage name="PrimaryLocationName" />
          </span>
        </div>
        <div className="form-group">
          <label className="form-lable">Type</label>
          <Typeahead
            id="basic-typeahead-multiple"
            options={this.props.orgTypes}
            placeholder=""
            labelKey="name"
            name="Type"
            onChange={(selectedOptions) => {
              props.setFieldValue("Type", selectedOptions);
              // props.setFieldTouched("Type", true, true);
            }}
            onBlur={() => {
              props.setFieldTouched("Type", true, true);
            }}
            ref={(ref) => (this._orgTypeTypeahead = ref)}
            multiple
            allowNew
          />
          <span className="error_text">
            <ErrorMessage name="Type" />
          </span>
        </div>
        <div className="form-group">
          <label className="form-lable">Specialty</label>
          <Typeahead
            id="basic-typeahead-multiple"
            options={this.props.specialities}
            labelKey="name"
            placeholder=""
            name="speciality"
            onChange={(selectedOptions) => {
              props.setFieldValue("speciality", selectedOptions);
              // props.setFieldTouched("speciality", true, true);
            }}
            onBlur={() => {
              props.setFieldTouched("speciality", true, true);
            }}
            ref={(ref) => (this._typeahead = ref)}
            multiple
            allowNew
          />
          <span className="error_text">
            {" "}
            <ErrorMessage name="speciality" />
          </span>
        </div>
        <div
          className="row mt-5 no-gutter"
          style={{ marginLeft: "0px", marginRight: "0px" }}
        >
          <div style={{ margin: "auto 10px auto auto", display: "flex" }}>
            <div
              className="location-icon"
              style={{ cursor: "pointer" }}
              onClick={() => this.onSubmitWithAdd()}
            />
          </div>
          <div
            style={{
              display: "flex",
              textAlign: "left",
              margin: "auto auto auto 0px",
            }}
          >
            <span
              className="form-link"
              onClick={() => this.onSubmitWithAdd()}
              style={{ height: "37px", lineHeight: "37px" }}
            >
              Save and create another location
            </span>
          </div>
        </div>
        <div className="mt-5 text-right">
          {/* chnages */}
          {/* {this.props.onBoarding === true && (
            <button
              type="button"
              className="btn mr-3 pull-left form-btn"
              onClick={this.goLastStep}
            >
              Back
            </button>
          )} */}
          {this.props.canSkip ? (
            <span
              className="form-link mr-5"
              onClick={() => this.props.onSkipForNow()}
            >
              Skip for now
            </span>
          ) : null}
          <button
            type="button"
            className="btn form-btn"
            id="btnLogin"
            onClick={() => this.onSubmitwithoutAdd()}
          >
            Next
            {this.props.isSaveInProgress === true ? (
              <span className="text-right pl-2">
                <i
                  className="fa fa-circle-o-notch fa-spin"
                  style={{ color: "#212529" }}
                />
              </span>
            ) : (
              ""
            )}
          </button>
        </div>
      </form>
    );
  };

  render() {
    return (
      <div className="container">
        <div className="form-rectangle">
          <div className="form-header">
            <h3>LET'S SET UP YOUR LOCATIONS…</h3>
            <p>
              Each organization can have a single primary location and multiple
              secondary ones.
            </p>
          </div>
          <div className="form-container h-100">
            <div className="row">
              <div className="col-4">
                <div className="form-lText ">
                  Your primary location is tied to your admin account. All users
                  are tied either to this location or secondary ones (like
                  individual clinics or offices).
                </div>
                <div className="oval location-oval" />
              </div>
              <div className="col-8">
                <div className="form-body">
                  <Formik
                    innerRef={this.locationForm}
                    initialValues={{
                      Country: "",
                      PrimaryAddress: "",
                      City: "",
                      State: "",
                      Zipcode: "",
                      Phone: "",
                      Fax: "",
                      LocationContact: "",
                      LocationContactEmail: "",
                      PrimaryLocationName: "",
                      Type: [],
                      speciality: [],
                    }}
                    onSubmit={this.onSubmit}
                    render={this.renderForm}
                    validationSchema={this.validationSchema}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
